// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import CaymanIslands from '../_raw/flag/icon_flag_cayman_islands.png';

export default () => <img src={CaymanIslands} alt="CaymanIslands" />;
